function UniversalRangeSlider(config) {
  const defaultConfig = {
    step: 5,
    minValue: 5,
    maxValue: 100,
    currency: "AED",
    colors: {
      track: "#ccc",
      selection: "#a00ef0",
    },
  };

  const mergedConfig = { ...defaultConfig, ...config };

  const {
    container,
    minInputSelector,
    maxInputSelector,
    minLabelSelector,
    maxLabelSelector,
    hiddenMinInputSelector,
    hiddenMaxInputSelector,
    selectedRangeSelector,
    sliderTrackSelector,
  } = mergedConfig;

  const containerElement =
    typeof container === "string"
      ? document.querySelector(container)
      : container || document.body;

  const elements = {
    container: containerElement,
    minSlider: containerElement.querySelector(minInputSelector),
    maxSlider: containerElement.querySelector(maxInputSelector),
    sliderTrack: containerElement.querySelector(sliderTrackSelector),
    minLabel: containerElement.querySelector(minLabelSelector),
    maxLabel: containerElement.querySelector(maxLabelSelector),
    hiddenMinValue: containerElement.querySelector(hiddenMinInputSelector),
    hiddenMaxValue: containerElement.querySelector(hiddenMaxInputSelector),
    selectedRange: containerElement.querySelector(selectedRangeSelector),
  };

  const requiredElements = [
    "container",
    "minSlider",
    "maxSlider",
    "sliderTrack",
    "minLabel",
    "maxLabel",
    "hiddenMinValue",
    "hiddenMaxValue",
  ];

  for (const key of requiredElements) {
    if (!elements[key]) {
      console.error(
        `UniversalRangeSlider: Required element "${key}" not found`,
      );
      return;
    }
  }

  function formatValue(value, includePrefix = true) {
    const formatted = `${value}K`;
    return includePrefix ? `${mergedConfig.currency} ${formatted}` : formatted;
  }

  function updateSlider() {
    let currentMin = parseInt(elements.minSlider.value);
    let currentMax = parseInt(elements.maxSlider.value);

    if (currentMin > currentMax) {
      [currentMin, currentMax] = [currentMax, currentMin];
      elements.minSlider.value = currentMin;
      elements.maxSlider.value = currentMax;
    }

    const minPercent =
      ((currentMin - mergedConfig.minValue) /
        (mergedConfig.maxValue - mergedConfig.minValue)) *
      100;
    const maxPercent =
      ((currentMax - mergedConfig.minValue) /
        (mergedConfig.maxValue - mergedConfig.minValue)) *
      100;

    elements.sliderTrack.style.background = `linear-gradient(
      to right,
      ${mergedConfig.colors.track} ${minPercent}%,
      ${mergedConfig.colors.selection} ${minPercent}%,
      ${mergedConfig.colors.selection} ${maxPercent}%,
      ${mergedConfig.colors.track} ${maxPercent}%
    )`;

    const formattedMax =
      currentMax === mergedConfig.maxValue
        ? `${formatValue(currentMax)}+`
        : formatValue(currentMax);

    elements.minLabel.textContent = formatValue(currentMin);
    elements.maxLabel.textContent = formattedMax;
    elements.hiddenMinValue.value = formatValue(currentMin);
    elements.hiddenMaxValue.value = formattedMax;

    if (elements.selectedRange) {
      elements.selectedRange.textContent = `${formatValue(
        currentMin,
        false,
      )} - ${formatValue(currentMax, false)}`;
    }
  }

  function addEventListeners() {
    elements.minSlider.addEventListener("input", updateSlider);
    elements.maxSlider.addEventListener("input", updateSlider);
    ["touchstart", "touchmove"].forEach((event) => {
      elements.minSlider.addEventListener(event, updateSlider);
      elements.maxSlider.addEventListener(event, updateSlider);
    });
  }

  elements.minSlider.step = elements.maxSlider.step = mergedConfig.step;
  addEventListeners();
  updateSlider();
}

export default UniversalRangeSlider;